<template>
  <div v-if="($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD">
    <el-tooltip class="ml-2" content="More options" placement="top">
      <el-dropdown trigger="click" @command="handleCommand">
        <template v-if="!circle">
          <span class="el-dropdown-link"><i class="el-icon-more"></i> </span>
        </template>
        <template v-else><el-button icon="el-icon-more" circle size="mini" /></template>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="ctaPremission" icon="el-icon-edit" command="edit">Edit</el-dropdown-item>
          <el-dropdown-item v-if="ctaPremission" icon="el-icon-plus" command="add-assets">Add assets</el-dropdown-item>
          <el-dropdown-item icon="el-icon-copy-document" command="duplicate">Duplicate</el-dropdown-item>
          <el-dropdown-item v-if="ctaPremission" icon="el-icon-delete" command="delete">Delete</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-tooltip>
  </div>
</template>
<script>
import DeleteFlight from '@/components/social-products/social-boost/modal/DeleteFlight.vue'
export default {
  name: 'TableAction',
  props: {
    campaign: {
      type: [Object, Boolean],
      required: true,
    },
    flight: {
      type: null,
      required: true,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    redirectTo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ctaPremission() {
      return this.flight ? [0, 1].includes(this.flight.status) : true
    },
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'edit':
          this.$router.push({
            name: 'social-boost-edit-flight',
            params: { id: this.campaign.id, flight_id: this.flight.id },
          })
          break
        case 'delete':
          this.$Modal.init(
            {
              propsData: {
                component: DeleteFlight,
                meta: { flight: this.flight, redirectTo: this.redirectTo },
                size: '480px',
              },
              callback(payload) {
                if (payload.event === 'modal:close') {
                }
              },
            },
            this
          )
          break
        case 'add-assets':
          this.$router.push({
            name: 'social-boost-add-assets',
            params: { id: this.campaign.id, flight_id: this.flight.id },
            query: this.$route.name === 'view-flight-assets' ? { redirect: 'view-flight-assets' } : {},
          })
          break
        case 'duplicate':
          this.$store.dispatch('socialBoostCampaign/duplicateFlight', {
            flightId: this.flight.id,
            campaignId: this.campaign.id,
          })
          break
        default:
          break
      }
    },
  },
}
</script>
